import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  portfolioData: [],
};

const portfolioSlice = createSlice({
  name: "portfolio",
  initialState,
  reducers: {
    setPortfolioData(state, action) {
      state.portfolioData = action.payload;
    },
  },
});

export const { setPortfolioData } = portfolioSlice.actions;
export default portfolioSlice.reducer;
